var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08418 0.501233C0.674194 0.988561 0.466863 1.61225 0.504317 2.24558V29.7581C0.468983 30.3912 0.676064 31.0141 1.08418 31.5025L1.17906 31.5965L16.7299 16.1794V15.8138L1.17906 0.407227L1.08418 0.501233Z",
    fill: "url(#paint0_linear_197_106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.917 21.3185L16.7299 16.1795V15.8139L21.917 10.6853L22.033 10.748L28.1795 14.2053C29.9402 15.1872 29.9402 16.8062 28.1795 17.7985L22.033 21.2558L21.917 21.3185Z",
    fill: "url(#paint1_linear_197_106)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.033 21.2558L16.7615 16.0332L1.08418 31.5025C1.44554 31.7968 1.89544 31.9637 2.36306 31.977C2.83068 31.9902 3.28946 31.849 3.6672 31.5756L22.0014 21.2558",
    fill: "url(#paint2_linear_197_106)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.033 10.748L3.6672 0.417734C3.29352 0.133105 2.83169 -0.0141658 2.36058 0.00107454C1.88948 0.0163149 1.43833 0.193121 1.08418 0.501296L16.7299 16.0019L22.033 10.748Z",
    fill: "url(#paint3_linear_197_106)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.917 21.1409L3.66718 31.398C3.30315 31.6668 2.86129 31.8119 2.4073 31.8119C1.95332 31.8119 1.51146 31.6668 1.14742 31.398L1.05254 31.492L1.14742 31.586C1.51146 31.8548 1.95332 31.9999 2.4073 31.9999C2.86129 31.9999 3.30315 31.8548 3.66718 31.586L22.0013 21.2662L21.917 21.1409Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1.08417 31.3354C0.675372 30.8433 0.468376 30.2169 0.504308 29.5806V29.7581C0.468974 30.3912 0.676055 31.0141 1.08417 31.5025L1.17906 31.4085L1.08417 31.3354Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M28.1795 17.6105L21.917 21.141L22.033 21.2559L28.1795 17.7568C28.54 17.5997 28.852 17.3506 29.0835 17.035C29.3151 16.7193 29.4579 16.3484 29.4974 15.9602C29.4254 16.3191 29.2684 16.6559 29.0393 16.9428C28.8101 17.2297 28.5155 17.4586 28.1795 17.6105Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.66701 0.605715L28.1793 14.3829C28.512 14.5311 28.8047 14.7549 29.0337 15.0362C29.2627 15.3175 29.4215 15.6484 29.4972 16.0019C29.4599 15.613 29.3179 15.2412 29.0861 14.9252C28.8543 14.6092 28.5411 14.3606 28.1793 14.2053L3.66701 0.417702C1.93797 -0.564143 0.504135 0.25058 0.504135 2.24561V2.42317C0.504135 0.438593 1.93797 -0.386575 3.66701 0.605715Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_106",
    x1: 15.3593,
    y1: 1.95311,
    x2: -5.51967,
    y2: 23.0275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_106",
    x1: 28.3903,
    y1: 16.0019,
    x2: -1.99436,
    y2: 16.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_106",
    x1: 19.1548,
    y1: 18.8534,
    x2: -9.1504,
    y2: 47.4235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_106",
    x1: -2.85887,
    y1: -8.65911,
    x2: 9.78977,
    y2: 4.09738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.efecdde45adff6c6562b096d62f3b643.svg";
export { ForwardRef as ReactComponent };